import React, { useEffect, useRef } from "react";
import Swiper from "swiper";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function CertificationsSlider() {
  const swiperRef = useRef(null);
  const swiperInstance = useRef(null);

  useEffect(() => {
    if (swiperRef.current) {
      swiperInstance.current = new Swiper(swiperRef.current, {
        modules: [Autoplay, Pagination],

        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,

        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },

        pagination: {
          el: ".cert-pagination",
          clickable: true,
        },

        breakpoints: {
          0: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        },
      });
    }

    return () => {
      if (swiperInstance.current) {
        swiperInstance.current.destroy(true, true);
      }
    };
  }, []);

  return (
    <>
      {/* Slider */}
      <div className="swiper cert-swiper padding-container" ref={swiperRef}>
        <div className="slider-3-heading">
          <h1 style={{ textAlign: "center" }}>
            PROUD <span className="orange-text">MEMBER OF</span>
          </h1>
        </div>
        <div className="swiper-wrapper">
          {/* pasha */}
          <div className="certification-swiper-slide swiper-slide">
            <img
              src="/assets/Images/Group 50.png"
              alt="Certification 1"
              className="slide-img"
            />
          </div>

          {/* PSEB */}
          <div className="certification-swiper-slide swiper-slide">
            <img
              src="/assets/Images/Group 51.png"
              alt="Certification 2"
              className="slide-img"
            />
          </div>

          {/* pessi */}
          <div className="certification-swiper-slide swiper-slide">
            <img
              src="/assets/Images/pessi.png"
              alt="Certification 5"
              className="slide-img FBR"
            />
          </div>

          {/* PSW */}
          <div className="certification-swiper-slide swiper-slide">
            <img
              src="/assets/Images/Group 52.png"
              alt="Certification 3"
              className="slide-img"
            />
          </div>
          
          {/* FBR */}
          <div className="certification-swiper-slide swiper-slide">
            <img
              src="/assets/Images/new fbr.jpg"
              alt="Certification 5"
              className="slide-img FBR"
            />
          </div>
          {/* GTCCI */}
          <div className="certification-swiper-slide swiper-slide">
            <img
              src="/assets/Images/Group 53.png"
              alt="Certification 4"
              className="slide-img"
            />
          </div>

          
        </div>
      </div>

      {/* Internal CSS */}
      <style>
        {`
  /* =========================
     MOBILE DEVICES (0px - 767px)
     ========================= */
  @media (max-width: 767px) {

    .cert-swiper {
      padding: 25px 8px;
    }

    .cert-swiper .certification-swiper-slide {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .slide-img {
      max-width: 240px;
      width: 100%;
      height: auto;
      object-fit: contain;
    }

    .cert-pagination {
      margin-top: 15px;
    }

    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      background: #D32F2F;
      opacity: 0.6;
    }

    .swiper-pagination-bullet-active {
      opacity: 1;
    }
  }


  /* =========================
     TABLET DEVICES (768px - 1023px)
     ========================= */
  @media (min-width: 768px) and (max-width: 1100px) {

    .cert-swiper {
      padding: 40px 0;
    }

    .cert-swiper .certification-swiper-slide {
  
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .slide-img {
      max-width: 300px;
      width: 100%;
      height: auto;
      object-fit: contain;
    }

    .cert-pagination {
      margin-top: 18px;
    }

    .swiper-pagination-bullet {
      width: 10px;
      height: 10px;
      background: #D32F2F;
      opacity: 0.7;
    }

    .swiper-pagination-bullet-active {
      opacity: 1;
    }
  }
`}
      </style>
    </>
  );
}

export default CertificationsSlider;
